export const ONYX_OPEN_AFTER_LOAD_KEY = 'komby_onyx_open_after_load';
